// Petites règles de chargement, sans dépendance : testables seules.

// Au retour sur l'onglet, on ne recharge tout que si le dernier chargement
// réussi date d'au moins 5 minutes : les messages arrivent déjà en direct.
// Au retour du RÉSEAU, on recharge toujours : le direct ne rejoue pas les
// messages arrivés pendant la coupure.
export const DELAI_RECHARGEMENT_MS = 5 * 60 * 1000;

export function doitRechargerAuRetour(dernierChargement, maintenant, typeEvenement) {
  if (typeEvenement === "online") return true;
  return maintenant - dernierChargement >= DELAI_RECHARGEMENT_MS;
}

// Charge un morceau de page. Si le morceau n'existe plus (onglet resté ouvert
// pendant une publication), on recharge la page UNE seule fois pour prendre la
// nouvelle version. Si ça échoue encore, ou si le navigateur refuse le
// stockage, l'erreur remonte : jamais de rechargement en boucle.
const DRAPEAU = "recharge-apres-echec";

function stockageSur() {
  try { return window.sessionStorage; } catch { return null; }
}

export function importAvecReprise(importer, { stockage, recharger = () => window.location.reload() } = {}) {
  const st = stockage === undefined ? stockageSur() : stockage;
  return importer().then(
    mod => {
      try { if (st) st.removeItem(DRAPEAU); } catch {}
      return mod;
    },
    err => {
      let dejaRecharge = true;
      try {
        if (st) {
          dejaRecharge = st.getItem(DRAPEAU) === "1";
          if (!dejaRecharge) st.setItem(DRAPEAU, "1");
        }
      } catch {
        dejaRecharge = true;
      }
      if (dejaRecharge) throw err;
      recharger();
      return new Promise(() => {}); // la page se recharge : on n'affiche rien d'autre
    }
  );
}
